module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment03-b2c314889616acc38443d3e84b0bab08.png";